import moment from "moment";
import { FormatNumber2 } from "../../../utility/functions/formatNumber";

export const SummaryColumns = (width) => {
  const columns = [
    {
      field: "ACCOUNT_NO",
      accessor: "ACCOUNT_NO",
      type: "string",
      width: width < 768 ? 100 : width < 1400 ? 120 : 120,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center  px-1 `}>
            {param.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          {" "}
          Account No.
        </div>
      ),
    },
    {
      field: "NAME",
      accessor: "NAME",
      type: "string",
      width: width < 768 ? 100 : width < 1400 ? 230 : 230,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center  px-1 `}>
            {param.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          {" "}
          Account Name
        </div>
      ),
    },

    {
      field: "UNDER_GROUP",
      accessor: "UNDER_GROUP",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: width < 768 ? 230 : 230,
      align: "left",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center   px-1`}>
            {param.value}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Under group
        </div>
      ),
    },
    {
      field: "DEBIT",
      accessor: "DEBIT",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: width < 768 ? 100 : 90,
      align: "right",
      renderCell: (param) => {
        return (
          <div
            className={` h-full w-full  flex items-center  justify-end px-1`}
          >
            {param.value !== "0" ? FormatNumber2(param.value) : ""}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Debit
        </div>
      ),
    },
    {
      field: "CREDIT",
      accessor: "CREDIT",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: width < 768 ? 120 : 120,
      align: "right",
      renderCell: (param) => {
        return (
          <div
            className={` h-full w-full  flex items-center  justify-end px-1`}
          >
            {param.value !== "0" ? FormatNumber2(param.value) : ""}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Credit
        </div>
      ),
    },
  ];

  return columns;
};
